// extracted by mini-css-extract-plugin
export default {"container":"Pl-z","bubbleNav":"Ql-z","graphic":"Rl-z","contact":"Sl-z"};